import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import ModalsPopup from "../../Modals/ModalsPopup"
import { StyledButton } from "../../Styled/Button"
import { withBackInStockPopup } from "./withBackInStockPopup"
import { StyledH6 } from "../../Styled/Text"

const Wrapper = tw.div`w-full rounded-1 bg-light`
const Content = tw.div`w-full p-1-6 md:p-3-2`
const Inner = tw.div`flex flex-col items-start`

const Title = styled.div`
  ${tw`uppercase mb-1-6`}
  ${({ submited }) => (submited ? tw`text-center` : null)}
` // styledsmall
const Description = styled(StyledH6)`
  ${tw` mb-3-2`}
  ${({ submited }) => (submited ? tw`text-center` : null)}
`
const Email = tw.form`relative flex items-center justify-between border border-dark rounded-1 w-30 md:w-full max-w-full`
const Input = styled.input`
  ${tw`w-full font-body text-16 md:text-18 px-1 h-3-2 md:h-4 leading-1 rounded-1 outline-none focus:outline-none bg-lightest placeholder-dark`}
  ${({ popup }) => (popup ? tw`bg-lightest` : tw``)}
`
const Button = tw(StyledButton)`border-l border-t-0 border-r-0 border-b-0 h-3-2 md:h-4`

const BackInStockPopup = withBackInStockPopup(({ loading, sent, errors, email, handleChange, handleSubmit, active, setActive }) => {
  return (
    <ModalsPopup active={active} setActive={setActive} notify>
      <Wrapper>
        <Content>
          {!sent && !errors & !loading ? (
            <Inner>
              <Title className="body_small_highlight">{`dang! we’re out of this one`}</Title>
              <Description>{`Notify me when back in stock…`}</Description>

              <Email onSubmit={handleSubmit}>
                <Input name="email" type="email" value={email} onChange={handleChange} placeholder={`Your email`} />
                <Button
                  type={`submit`}
                  disabled={loading}
                  layout={`primary`}
                  textsize={`lg-tight`}
                  colour={`transparent`}
                  background={`lightest`}
                  className={`primary_button`}
                >
                  {`Go!`}
                </Button>
              </Email>
            </Inner>
          ) : sent ? (
            <>
              <Title className="body_small_highlight" submited>{`Done!`}</Title>
              <Description submited>{`You’ll receive an email once this item is back in stock.`}</Description>
            </>
          ) : errors ? (
            <>
              <Title className="body_small_highlight" submited>{`Oops!`}</Title>
              <Description submited>{`Something did not go as planned. Please try again later.`}</Description>
            </>
          ) : loading ? (
            <>
              <Title className="body_small_highlight" submited>{`Sending...`}</Title>
              <Description submited>{`Notify me when back in stock…`}</Description>
            </>
          ) : null}
        </Content>
      </Wrapper>
    </ModalsPopup>
  )
})

export default BackInStockPopup
